<template>
  <div class="flex flex-col px-3 gap-1 text-n-0 font-body text-sm leading-4">
    <div
      v-for="billDiscount in billsDiscounts"
      :key="billDiscount.amount"
      class="flex justify-between"
    >
      <div class="flex gap-1">
        <div>{{ t('tabs.discount') }}</div>
        <div v-if="billDiscount.type === 'percentage'">{{ billDiscount.amount }}%</div>
      </div>
      <div>-{{ currency(billDiscount.discountTotal) }}</div>
    </div>

    <div v-if="minimumBasketSurcharge" class="flex justify-between">
      <div>
        {{ t('tabs.minimum-basket-surcharge') }}
      </div>
      <div>
        {{ currency(minimumBasketSurcharge) }}
      </div>
    </div>

    <div v-if="deliveryFee.isFree || deliveryFee.value > 0" class="flex justify-between">
      <div>{{ t('ordering.delivery-fee') }}</div>
      <div v-if="deliveryFee.isFree">
        {{ t('ordering.free-delivery') }}
      </div>
      <div v-else>{{ currency(deliveryFee.value) }}</div>
    </div>

    <div v-if="extraCharges" class="flex justify-between items-center">
      <div class="text-sm">{{ t('tabs.extra-charges') }}</div>
      <div>
        {{ currency(extraCharges) }}
      </div>
    </div>

    <div class="flex items-center justify-between font-heading font-medium text-sm h-5">
      <div>{{ t('tabs.total') }}</div>
      <div>{{ currency(total!) }}</div>
    </div>

    <div
      v-if="totalPending > 0"
      class="flex items-center justify-between font-heading font-medium text-base h-5 text-[#FF9898]"
    >
      <div>{{ t('checkout.due') }}</div>
      <div>{{ currency(totalPending) }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { useMoney } from '@/composables/useMoney'
import { useTabs } from '@/composables/useTabs'

const { t } = useI18n()

type Props = {
  tabId: string
}

const props = defineProps<Props>()

const { total, totalPending, deliveryFee, minimumBasketSurcharge, extraCharges, billsDiscounts } =
  useTabs(() => props.tabId)
const { currency } = useMoney()
</script>
